<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <mat-stepper
      #linearVerticalStepper="matVerticalStepper"
      formArrayName="scpis"
      [linear]="true"
      (selectionChange)="stepClick($event)"
    >
      @for (scpi of scpis.controls; track scpi; let i = $index) {
        @if (productIds?.includes(scpi.get('productId')?.value)) {
          <mat-step
            [formGroup]="scpi"
            [stepControl]="scpis?.get([i])"
            completed="false"
          >
            <ng-container formGroupName="parameters">
              <ng-template matStepLabel>{{
                scpi?.get('productName')?.value
              }}</ng-template>
              <div class="row row-flex">
                <div class="col col-md-12">
                  <pr-input-radio
                    [derrors]="derrors"
                    formControlName="scpiProgrammedPayment"
                    columns="3"
                    [toggle]="true"
                    [isDefault]="false"
                    label="Voulez-vous effectuer des versements programmés ?"
                  >
                  </pr-input-radio>
                </div>
                @if (
                  scpi?.get('parameters').get('scpiProgrammedPayment')?.value
                ) {
                  <div class="col col-md-12">
                    <pr-input-column
                      label="Versement mensuel montant"
                      [derrors]="derrors"
                      suffix="€/mois"
                    >
                      <input
                        formControlName="scpiProgrammedMontlyPaymentAmount"
                        type="number"
                        inputmode="numeric"
                      />
                    </pr-input-column>
                  </div>
                }
              </div>
            </ng-container>
          </mat-step>
        }
      }
    </mat-stepper>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
